import React, {Component} from 'react';
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from "@material-ui/core/Menu";
import ListSubheader from "@material-ui/core/ListSubheader";
import MenuItem from "@material-ui/core/MenuItem";

interface Props {
    selectAll: () => void;
    deselectAll: () => void;
    invertAll: () => void;
}

interface State {
    optionAnchor: any;
}

class MenuSelection extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            optionAnchor: null,
        }
    }

    private handleMenuOpen = (event: any) => {
        this.setState({ optionAnchor: event.currentTarget });
    };

    private handleMenuClose = () => {
        this.setState({ optionAnchor: null });
    };

    render() {
        const ITEM_HEIGHT = 48;
        const{ selectAll, deselectAll, invertAll } = this.props;
        const { optionAnchor } = this.state;
        const open = Boolean(optionAnchor);
        return (
            <React.Fragment>
                <IconButton
                    id="icon-button"
                    aria-label="More"
                    aria-owns={open ? 'long-menu' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleMenuOpen}
                >
                    <MoreVertIcon id="more-vert" />
                </IconButton>
                <Menu
                    id="long-menu"
                    anchorEl={optionAnchor}
                    open={open}
                    onClose={this.handleMenuClose}
                    PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: 200,
                        },
                    }}
                >
                    <ListSubheader>Selections</ListSubheader>
                    <MenuItem
                        key="Select"
                        onClick={() => {
                            selectAll();
                            this.handleMenuClose();
                        }}
                    >
                        Select all
                    </MenuItem>
                    <MenuItem
                        key="Deselect"
                        onClick={() => {
                            deselectAll();
                            this.handleMenuClose();
                        }}
                    >
                        Deselect all
                    </MenuItem>
                    <MenuItem
                        key="Invert"
                        onClick={() => {
                            invertAll();
                            this.handleMenuClose();
                        }}
                    >
                        Invert selection
                    </MenuItem>
                </Menu>
            </React.Fragment>
        );
    }
}

export default MenuSelection;